import type { DialoguePool } from '@/state/types';

export const L09_DIALOGUE: DialoguePool = {
  slowPlay: [
    'One option is truth. The others are... career advice.',
    'One of the four options is accurate. Three are editorial.',
    'Not a click. A drag. I\u2019m precise about this. I\u2019ve always been precise.',
  ],
  tokenLoss: [
    'Incorrect dialect. The oscilloscope sighs, audibly, in 7-bit.',
    'Maybe next time. The scream continues at no additional cost.',
    'A Safari Hat heard a C-sharp. It\u2019s tone-deaf.',
  ],
  solution: [
    'Correct. That is the sound of a civilisation connecting at 28.8 kilobits per second.',
    'Pure Agony. Diagnosed correctly; evolution still in tact. You might have a chance at solving this quiz!',
    'Now that\u2019s music. Moving on.',
  ],
  spite: [
    'The scream is familiar now. It\u2019s practically furniture.',
  ],
};
